export const joiningRequestStatuses = {
  pending: "pending",
  joined: "joined",
  rejected: "rejected",
  removed: "removed",
};

// Cancelled / auto-cancelled requests are excluded: re-approving them is not
// supported by the API yet, so the rejected list is scoped to `rejected` only.
export const joiningRequestRejectedApiStatuses = "rejected";

export const joiningRequestApiStatuses = {
  [joiningRequestStatuses.pending]: "pending",
  [joiningRequestStatuses.joined]: "approved",
  [joiningRequestStatuses.rejected]: joiningRequestRejectedApiStatuses,
  [joiningRequestStatuses.removed]: "removed",
};

export const apiStatusToJoiningRequestStatus = {
  pending: joiningRequestStatuses.pending,
  approved: joiningRequestStatuses.joined,
  rejected: joiningRequestStatuses.rejected,
  cancelled: joiningRequestStatuses.rejected,
  canceled: joiningRequestStatuses.rejected,
  removed: joiningRequestStatuses.removed,
  auto_cancelled: joiningRequestStatuses.rejected,
};
